export const DISBURSEMENTS = {
  key: "disbursements",
  abbr: "dis",
  label: "Disbursements",
  flag: "module-disbursements"
};

export const IPC_CONFIGURATION = {
  key: "ipc-configuration",
  abbr: "ipcc",
  label: "Configurations",
  flag: "module-ipc-configuration"
};

export const QUICK_VIEW = {
  key: "quick-view",
  abbr: "qv",
  label: "Quick View",
  flag: "module-quick-view"
};

export const QUOTES_AND_POLICIES = {
  key: "quotes-and-policies",
  abbr: "qandp",
  label: "Quotes & Policies",
  flag: "module-qandp"
};

export const REFERRALS = {
  key: "referrals",
  abbr: "ref",
  label: "Referrals",
  flag: "module-referrals"
};

export const RENEWALS = {
  key: "renewals",
  abbr: "rmm",
  label: "Renewals",
  flag: "module-renewals"
};

export const RENEWAL_UNDERWRITING = {
  key: "renewal-underwriting",
  abbr: "rr",
  label: "Renewal Underwriting",
  flag: "module-renewal-underwriting"
};

export const TRANSACTION_BATCHES = {
  key: "transaction-batches",
  abbr: "tb",
  label: "Transaction Batches",
  flag: "module-transaction-batches"
};

export const AUTH_MANAGER = {
  key: "auth-manager",
  abbr: "am",
  label: "Auth Manager",
  flag: "module-auth-manager",
  roles: ["AUTH_MANAGER", "AUTH_ROLE_ADMIN"]
};

export const MODULES = [
  IPC_CONFIGURATION,
  QUICK_VIEW,
  QUOTES_AND_POLICIES,
  REFERRALS,
  AUTH_MANAGER
];

export const MAIN_NAV = [
  QUOTES_AND_POLICIES,
  REFERRALS,
  IPC_CONFIGURATION,
  QUICK_VIEW,
  AUTH_MANAGER
];
